import { koComponent } from "../../ko-utils";
import $api from "../../api";
import { CompanyJoinRequestModel } from "../../models/Gen/BaseModels";

class CompanyJoinsView {
  constructor(params, parentPage) {
    this.joins = ko.observableArray();

    this.parentPage = parentPage;

    this.ButtonLock = ko.observable(false);

    this.isLoaded = ko.observable(false);

    this.load();
  }

  load() {
    $api.company.getJoins({}, {}, (resp) => {
      this.joins.removeAll();
      this.isLoaded(true);

      for (const join of resp) {
        const i = new CompanyJoinRequestModel(join);
        this.joins.push(i);
      }
    });
  }

  acceptJoin(join) {
    if (ko.unwrap(this.ButtonLock)) {
      return;
    }

    this.ButtonLock(true);

    $api.company.resolveJoin(
      {},
      {
        JoinId: ko.unwrap(join.id),
        Accept: true,
      },
      (resp) => {
        this.load();
      }
    );

    setTimeout(() => {
      this.ButtonLock(false);
    }, 1000);
  }

  rejectJoin(join) {
    if (ko.unwrap(this.ButtonLock)) {
      return;
    }

    this.ButtonLock(true);
    $api.company.resolveJoin(
      {},
      {
        JoinId: ko.unwrap(join.id),
        Accept: false,
      },
      (resp) => {
        this.load();
      }
    );

    setTimeout(() => {
      this.ButtonLock(false);
    }, 1000);
  }
}

export default koComponent("company-joins-view", CompanyJoinsView);
